export default {"src":"/_next/static/media/trust-icon.099b53ad.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};